import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-grid-layout',
  templateUrl: './grid-layout.component.html',
  styleUrls: ['./grid-layout.component.sass']
})
export class GridLayoutComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
